import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/next@14.2.4_@babel+core@7.24.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/regenerator/index.js";
import Head from 'next/head';
import { getBlogPostsMetas } from 'lib/cms';
import Layout from 'components/Layout';
import LazyImage from 'components/LazyImage';
import Link from 'components/Link';
import CTANav from 'components/Navbars/CTANav';
import { FormatDate } from 'components/Time';
export var getStaticProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$preview, preview, blogPostMetas;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$preview = _ref.preview, preview = _ref$preview === void 0 ? false : _ref$preview;
          _context.next = 3;
          return getBlogPostsMetas(preview);
        case 3:
          blogPostMetas = _context.sent;
          return _context.abrupt("return", {
            props: {
              blogPostMetas: blogPostMetas,
              __previewMode: preview
            },
            revalidate: 3600 // revalidate: every hour, check if there are new blog posts
          });
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getStaticProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var Blog = function Blog(_ref3) {
  var blogPostMetas = _ref3.blogPostMetas;
  var featuredBlog = blogPostMetas[0];
  var gridBlogs = blogPostMetas.slice(1);
  return __jsx(Layout, {
    navbar: __jsx(CTANav, {
      cta: "Become a Host",
      ctaLink: "/host"
    })
  }, __jsx(Head, null, __jsx("title", null, "Blog | Wanderglade")), __jsx("section", {
    className: "section"
  }, __jsx("div", {
    className: "container mb-6"
  }, __jsx("h1", {
    className: "is-size-1 tw-text-ebony tw-font-bold mb-6"
  }, "Our Blogs"), featuredBlog ? __jsx(Link, {
    href: "blog/".concat(featuredBlog.slug)
  }, __jsx("div", {
    className: "flex items-center justify-between"
  }, __jsx("div", null, __jsx(LazyImage, {
    src: featuredBlog.headerImage.src,
    alt: featuredBlog.headerImage.title,
    objectPosition: "bottom",
    className: "tw-rounded-lg tw-h-[600px] tw-w-full"
  })), __jsx("div", {
    className: "tw-w-[40%] px-5"
  }, __jsx("p", {
    className: "font-secondary tw-font-semibold tw-text-ebony is-size-4 mb-3"
  }, featuredBlog.title), __jsx("p", {
    className: "is-size-7 tw-text-gray"
  }, __jsx(FormatDate, {
    time: featuredBlog.publishedDate,
    format: "MMMM do, yyyy"
  }))))) : !gridBlogs.length ? __jsx("p", null, "No posts at this time. Stay tuned!") : __jsx(React.Fragment, null)), gridBlogs.length ? __jsx("div", {
    className: "container tw-grid tw-grid-cols-3 tw-gap-6"
  }, gridBlogs.map(function (blog) {
    return __jsx(Link, {
      key: blog.slug,
      href: "blog/".concat(blog.slug)
    }, __jsx("div", {
      className: "flex flex-col tw-gap-2"
    }, __jsx(LazyImage, {
      src: blog.headerImage.src,
      objectPosition: "bottom",
      className: "tw-rounded-lg tw-h-[400px] tw-w-full"
    }), __jsx("div", null, __jsx("p", {
      className: "font-secondary tw-font-semibold tw-text-ebony mb-2"
    }, blog.title), __jsx("p", {
      className: "is-size-7 tw-text-gray"
    }, __jsx(FormatDate, {
      time: blog.publishedDate,
      format: "MMMM do, yyyy"
    })))));
  })) : __jsx(React.Fragment, null)));
};
export default Blog;